// **********************************************************
// Mod Map
// **********************************************************

const modMapInit = document.querySelectorAll('.mod-map__map-init');

modMapInit.forEach((el) => {
  const parentElem = el.closest('.mod-map');
  const mapInitElem = parentElem.querySelector('.mod-map__map-init');
  const locationElem = parentElem.querySelectorAll('[data-location]');

  // Global settings
  const mapZoom = mapInitElem.getAttribute('data-zoom');
  const mapCenterLat = mapInitElem.getAttribute('data-centerlat');
  const mapCenterLng = mapInitElem.getAttribute('data-centerlng');
  const mapId = mapInitElem.getAttribute('id');

  window.map = L.map(mapId, {
    // doubleClickZoom: false,
    scrollWheelZoom: false,
    center: [mapCenterLat, mapCenterLng],
    zoom: mapZoom,
  });

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
  }).addTo(map);

  window.markers = [];
  const markers = {};
  const popup = {};

  locationElem.forEach((ele) => {
    const innerMapLat = ele.getAttribute('data-lat');
    const innerMapLng = ele.getAttribute('data-lng');
    const newmapId = ele.getAttribute('data-id');
    const popupContent = ele.getAttribute('data-popup');
    const pinIcon = ele.getAttribute('data-pin');
    const country = ele.getAttribute('data-country');



    const greenIcon = L.icon({
      iconUrl: pinIcon,
      iconSize: [40, 62],
      iconAnchor: [20, 62],
      popupAnchor: [0, -30],
    });

    // eslint-disable-next-line new-cap
    markers[newmapId] = new L.marker([innerMapLat, innerMapLng], {
      icon: greenIcon,
    }).addTo(map);

    window.markers.push({
      marker: markers[newmapId],
      country,
      data: {
        innerMapLat,
        innerMapLng,
      },
    });

    popup[newmapId] = markers[newmapId].bindPopup(popupContent, {
      maxWidth: 250,
    });
  });
});
